/* eslint-disable max-len */
import cn from 'classnames';
import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import AboutWork from '../../components/AboutWork';
import DirectionDivisions from '../../components/DirectionDivisions';
import GalleryBlock from '../../components/GalleryBlock';
import LinksBlock from '../../components/LinksBlock';
import MainPageFooter from '../../components/MainPageFooter';
import MediaBlock from '../../components/MediaBlock';
import OfficeHeader from '../../components/OfficeHeader';
import OfficesBlock from '../../components/OfficesBlock';
import ScrollToTop from '../../components/ScrollToTop';
import StatisticBlock from '../../components/StatisticBlock';
import VideoBlock from '../../components/VideoBlock';
import {
  requestGetNews,
  requestOfficePage,
} from '../../redux/actions/main-page';
import { RootState } from '../../redux/reducers/rootReducer';
import { getNewsTabs } from '../../utils/constants/getNewsTabs';
import { SEO } from '../../utils/constants/seo';
import { IOfficePage } from '../../utils/types/state-types';
import { useDocumentSeo } from '../../utils/useDocumentSeo';
import classes from './office.module.scss';

function Office() {
  const isMobileSearchOpen = useSelector<RootState, boolean | undefined>(
    (state) => state.mainReducer.isSearchOpen,
  );
  const officePage = useSelector<RootState, IOfficePage | null>(
    (state) => state.mainReducer.officePage,
  );
  const isLoading = useSelector<RootState, boolean>(
    (state) => state.mainReducer.isLoading,
  );
  const news = useSelector<RootState, any>(
    (state) => state.newsReducer.responses,
  );
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(
      requestGetNews({
        division: getNewsTabs(location.pathname),
        mode: 'divisionPage',
      }),
    );
  }, []);

  useDocumentSeo(SEO.backOffice);

  useEffect(() => {
    if (!officePage) {
      dispatch(requestOfficePage());
    }
  }, [officePage]);

  return (
    <div
      className={cn({
        [classes.mainPageContainer]: true,
        [classes.hiddenMainPage]: isMobileSearchOpen,
      })}
    >
      <ScrollToTop showPosition={820} />
      <OfficeHeader />
      {/* Направления внутри направления */}
      {officePage?.divisionsBlockShow && (
        <DirectionDivisions
          title={officePage?.divisionsBlockTitle}
          subtitle={officePage?.divisionsBlockSubtitle}
          divisionsBlockCards={officePage?.divisionsBlockCards}
          rows={2}
        />
      )}

      {/* Блок с цифрами */}
      <StatisticBlock
        statisticBlockShow={officePage?.statisticBlockShow || false}
        statisticBlockTitle={officePage?.statisticBlockTitle || ''}
        statisticBlockCards={officePage?.statisticBlockCards || []}
      />

      {/* фичерсбокс */}
      {officePage && (
        <AboutWork
          data={officePage}
          button={{
            link: '/catalog-vacancies?division=BO&page=1',
            text: officePage?.aboutWorkButtonText || 'Смотреть все вакансии',
          }}
        />
      )}

      {/* Office */}
      <OfficesBlock {...officePage} />

      {/* Video Block */}
      <VideoBlock
        videoBlockShow={!!officePage?.videoBlockShow}
        videoLink={officePage?.videoLink}
        videoBlockTitle={officePage?.videoBlockTitle || ''}
        videoDescription={officePage?.videoBlockDescription || ''}
        videoTag={officePage?.videoBlockTag || ''}
      />

      {/* Gallery Block */}
      {officePage?.aboutTeamsShow && (
        <GalleryBlock images={officePage?.aboutTeamsCards} />
      )}

      {/* News Block */}
      {news.length !== 0 ? <MediaBlock news={news} title="СМИ о нас" /> : null}

      {/* Links Block */}
      <LinksBlock
        title={officePage?.linksBlockTitle || ''}
        linksBlockItems={officePage?.linksBlockItems || []}
        linksBlockShow={officePage?.linksBlockShow}
      />

      <MainPageFooter isLoadingContent={isLoading} />
    </div>
  );
}

export default memo(Office);
